import styled from 'styled-components';
import { MainColor } from '../style/styleValue';

const advisoryBoard = [
  { name: '김정선', affiliation: '삼성서울병원' },
  { name: '김나래', affiliation: '가톨릭대학교부천성모병원' },
  { name: '김은나', affiliation: '서울대학교병원' },
  { name: '전이경', affiliation: '고려대학교구로병원' },
  { name: '김현희', affiliation: '삼성서울병원' },
  { name: '황윤정', affiliation: '분당 서울대학교병원' },
  { name: '김종재', affiliation: '서울아산병원' },
  { name: '김연미', affiliation: '플러스랩병리과의원' },
  { name: '박성혜', affiliation: '씨젠의료재단' },
  { name: '박진우', affiliation: '국립암센터' },
  { name: '우창곡', affiliation: '충북대학교병원' },
  { name: '김성익', affiliation: '국립암센터' },
  { name: '정욱재', affiliation: '창원경상국립대학교병원' },
  { name: '김세훈', affiliation: '연세대학교 세브란스병원' },
  { name: '공준석', affiliation: '원자력병원' },
  { name: '한강희', affiliation: '제주한라병원' },
  { name: '원재경', affiliation: '서울대학교병원' },
  { name: '김한성', affiliation: '인제대학교 일산백병원' },
  { name: '김보미', affiliation: '해운대백병원' },
];

const advisoryBoard2 = [
  { name: '정의석', affiliation: '서울아산병원' },
  { name: '이주영', affiliation: '고대안암병원' },
];

const snuhTeam = [
  { name: '김은나', affiliation: '서울대학교병원' },
  { name: '심유미', affiliation: '서울대학교병원' },
  { name: '노윤서', affiliation: '서울대학교병원' },
  { name: '송현범', affiliation: '서울대학교병원' },
];

const developer = [
  { name: '김은성', affiliation: '(주)휴민텍' },
  { name: '김재민', affiliation: '(주)휴민텍' },
  { name: '김혁', affiliation: '(주)휴민텍' },
  { name: '윤나혜', affiliation: '(주)휴민텍' },
];

const Committee = () => {
  const renderTable = (data: any[]) => {
    const sortedData = [...data].sort((a, b) => a.name.localeCompare(b.name, 'ko'));

    return (
      <TableContainer>
        <Table>
          <thead>
            <tr>
              <Th>성함</Th>
              <Th>소속</Th>
            </tr>
          </thead>
          <tbody>
            {sortedData.map((item: any, index: number) => (
              <tr key={index}>
                <Td>{item.name}</Td>
                <Td>{item.affiliation}</Td>
              </tr>
            ))}
          </tbody>
        </Table>
      </TableContainer>
    );
  };

  return (
    <Container>
      <SectionTitle>소아희귀질환병리아틀라스와 함께 해주시는 분들 (병리과)</SectionTitle>
      {renderTable(advisoryBoard)}

      <SectionTitle>소아희귀질환병리아틀라스와 함께 해주시는 분들 (소아임상)</SectionTitle>
      {renderTable(advisoryBoard2)}

      <SectionTitle>서울대학교병원 소아아틀라스 운영진</SectionTitle>
      {renderTable(snuhTeam)}

      <SectionTitle>사이트 제작</SectionTitle>
      {renderTable(developer)}
    </Container>
  );
};

const Container = styled.div`
  width: 100%;
  max-width: 1200px;
  margin: 40px auto;
  padding: 20px;
  box-sizing: border-box;
  font-family: 'Pretendard', -apple-system, BlinkMacSystemFont, system-ui, Roboto, sans-serif;
`;

const SectionTitle = styled.h2`
  font-size: 1.25rem;
  font-weight: 700;
  color: #333;
  margin-bottom: 16px;
  padding-left: 8px;
  border-left: 4px solid ${MainColor};
`;

const TableContainer = styled.div`
  width: 100%;
  border-top: 2px solid #333;
  margin-bottom: 50px;
  overflow-x: auto;
`;

const Table = styled.table`
  width: 100%;
  border-collapse: collapse;
  text-align: left;
`;

const Th = styled.th`
  background-color: #f8f9fa;
  padding: 12px 16px;
  border-bottom: 1px solid #dee2e6;
  color: #555;
  font-weight: 600;
  width: 30%;
  white-space: nowrap;
`;

const Td = styled.td`
  padding: 12px 16px;
  border-bottom: 1px solid #dee2e6;
  color: #333;
  vertical-align: middle;
  word-break: keep-all;
`;

export default Committee;